import React from 'react';
import { getInitials } from '../../utils/helpers';

interface AvatarProps {
  src?: string;
  name?: string;
  size?: 'xs' | 'sm' | 'md' | 'lg' | 'xl';
  className?: string;
  /** Halo doble (surface + primary) como ObrosAvatar(ring: true). */
  ring?: boolean;
}

const sizes = {
  xs: 'w-6 h-6 text-xs',
  sm: 'w-8 h-8 text-sm',
  md: 'w-10 h-10 text-base',
  lg: 'w-12 h-12 text-lg',
  xl: 'w-16 h-16 text-xl',
};

// Paleta determinística de app/obros/lib/widgets/obros_avatar.dart (6 combos por letra inicial).
const palettes = [
  { bg: '#FE904D', fg: '#FFFFFF' },
  { bg: '#F7E8D3', fg: '#5A4321' },
  { bg: '#1A1614', fg: '#FBF2E4' },
  { bg: '#FE701A', fg: '#FFFFFF' },
  { bg: '#5A4B3A', fg: '#FBF2E4' },
  { bg: '#FEB080', fg: '#5A2A0A' },
];

const paletteFor = (name?: string) => {
  const code = name?.trim().charCodeAt(0) ?? 0;
  return palettes[code % palettes.length];
};

const ringShadow = { boxShadow: '0 0 0 3px #FFFFFE, 0 0 0 5px #FE904D' };

export const Avatar: React.FC<AvatarProps> = ({ src, name, size = 'md', className = '', ring = false }) => {
  if (src) {
    return (
      <img
        src={src}
        alt={name || 'Avatar'}
        style={ring ? ringShadow : undefined}
        className={`${sizes[size]} rounded-full object-cover border border-secondary-200 ${className}`}
      />
    );
  }

  const palette = paletteFor(name);

  return (
    <div
      style={{ backgroundColor: palette.bg, color: palette.fg, ...(ring ? ringShadow : {}) }}
      className={`${sizes[size]} rounded-full flex items-center justify-center font-semibold ${className}`}
    >
      {getInitials(name)}
    </div>
  );
};
